<template>
  <div class="pdf-view-component">
    <div class="pdf-scroll-area" ref="scrollArea">
      <div
        class="pdf-canvas-wrap"
        :style="widthCanvas > 0 ? { width: `${widthCanvas}px` } : null"
      >
        <canvas ref="pdfCanvas"></canvas>
      </div>
    </div>
    <el-button
      v-if="numPages > 0"
      class="button-nav button-prev"
      @click="onPrevPage"
      :disabled="pageNum === 1"
    >
      <i class="el-icon-arrow-left"></i>
    </el-button>
    <el-button
      v-if="numPages > 0"
      class="button-nav button-next"
      @click="onNextPage"
      :disabled="pageNum === numPages"
    >
      <i class="el-icon-arrow-right"></i>
    </el-button>
  </div>
</template>
<script>
import ExtensionService from '@/service/ExtensionService';
import * as PDFJS from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
export default {
  props: {
    fileId: {
      type: String,
      default: '',
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSign: {
      type: Number,
      default: 0,
    },
    syncDropzoneWidth: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      pdfDoc: null,
      pageNum: 1,
      numPages: 0,
      pageRendering: false,
      pageNumPending: null,
      currentRenderTask: null,
      scale: 1.4,
      widthCanvas: 0,
    }
  },
  methods: {
    async getDataPDF() {
      if (!this.fileId) return
      let urlPdf = ExtensionService.getPdfPreviewUrl
        ? ExtensionService.getPdfPreviewUrl(this.fileId)
        : ExtensionService.urlImg + this.fileId;
      PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      try {
        const pdfDoc_ = await PDFJS.getDocument(urlPdf).promise;
        this.pdfDoc = pdfDoc_;
        this.numPages = this.pdfDoc.numPages;
        const page = await pdfDoc_.getPage(1);
          const viewport = page.getViewport({ scale: 1 });
          const heightFile = viewport.height;
        this.$emit('pdfSize', {
          height: heightFile
        });
        this.renderPage(this.pageNum == 0 ? 1 : this.pageNum);
      } catch (error_) {
        console.log("error_error_",error_)
        if (error_.name == 'InvalidPDFException') {
          window.toastr.error('File không đúng định dạng PDF')
        } else {
          window.toastr.error('Có lỗi xảy ra, vui lòng thử lại')
        }
      }
    },
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.renderPage(pageNum);
    },
    //PDF methods
    /**
     * Get page info from document, resize canvas accordingly, and render page.
     * @param num Page number.
     */
    renderPage(num) {
      if (this.currentRenderTask) {
        try {
          this.currentRenderTask.cancel();
        } catch (e) {}
        this.currentRenderTask = null;
      }
      this.pageRendering = true;
      this.$emit('changePageNum', {pageNum: this.pageNum, numPages: this.numPages});
      let canvas = this.$refs.pdfCanvas;
      if (!canvas) return;
      let ctx = canvas.getContext('2d');
      if (!this.pdfDoc) return
      this.pdfDoc.getPage(num).then((page) => {
        var viewport = page.getViewport({scale: this.scale});
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Emit canvas dimensions
        this.$emit('canvasDimensions', {
          width: viewport.width,
          height: viewport.height
        });
        // Emit PDF page height (scale 1 = PDF points) cho trang hiện tại
        this.$emit('pdfSize', { 
          width: viewport.width / this.scale,
          height: viewport.height / this.scale 
        });

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        var renderTask = page.render(renderContext);
        this.currentRenderTask = renderTask;

        // Wait for rendering to finish
        renderTask.promise.then(() => {
          this.currentRenderTask = null;
          this.pageRendering = false;
          this.syncContainerWidth();
          if (this.pageNumPending !== null) {
            // New page rendering is pending
            const nextPending = this.pageNumPending;
            this.pageNumPending = null;
            this.renderPage(nextPending);
          }
          this.pageSign = 0;
        }).catch((err) => {
          if (err && err.name === 'RenderingCancelledException') {
            return;
          }
          console.warn('PDF render error:', err);
          this.currentRenderTask = null;
          this.pageRendering = false;
        });
      });
    },
    syncContainerWidth() {
      if (!this.syncDropzoneWidth) return;
      const canvas = this.$refs.pdfCanvas;
      const dropzone = this.$el ? this.$el.closest(".dropzone") : null;
      if (canvas && dropzone) {
        this.widthCanvas = canvas.width;
        dropzone.style.width = this.widthCanvas + "px";
      }
    },
    /**
     * If another page rendering in progress, waits until the rendering is
     * finised. Otherwise, executes rendering immediately.
     */
    queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
    /**
     * Displays previous page.
     */
    onPrevPage() {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--;
      this.queueRenderPage(this.pageNum);
    },

    /**
     * Displays next page.
     */
    onNextPage() {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return;
      }
      this.pageNum++;
      this.queueRenderPage(this.pageNum);
    }
  },
  mounted() {
    this.getDataPDF();
  },
  watch: {
    fileId(newId) {
      this.pageNum = this.currentPage || 1;
      this.getDataPDF();
    },
    currentPage(newPage) {
      this.pageNum = newPage;
      this.queueRenderPage(this.pageNum);
    },
    pageSign(newPage) {
      this.pageNum = newPage;
      this.queueRenderPage(this.pageSign);
    }
  },
}
</script>
<style lang="scss" scoped>
  .pdf-view-component {
    position: relative;
    width: 100%;
    height: 100%;

    .pdf-scroll-area {
      width: 100%;
      height: 100%;
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0 16px;
    }

    .pdf-canvas-wrap {
      position: relative;
      width: fit-content;
      flex-shrink: 0;
    }

    canvas {
      display: block;
    }

    .button-nav {
      border-radius: 8px;
      min-width: 40px;
      height: 40px;
      padding: 0;
      font-size: 18px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 120;
      border-color: #f28a54;
      color: #f28a54;
      background: #ffffff;
      transition: background-color 0.2s ease, color 0.2s ease,
        border-color 0.2s ease;

      &.button-prev { left: 8px; }
      &.button-next { right: 8px; }

      &:hover,
      &:focus {
        background: #f28a54;
        border-color: #f28a54;
        color: #ffffff;
      }

      &.is-disabled,
      &.is-disabled:hover,
      &.is-disabled:focus {
        background: #ffffff;
        border-color: #d0d0d0;
        color: #c0c4cc;
      }
    }
  }
</style>
